import * as React from "react";
import Component from "../../AbstractComponent";
import { PaymentInterface } from "../../../Entity/Entities/Payment/PaymentInterface";

export default class PaymentCounterpartyDescriptionInfoForList extends Component {	
  public render() {
		const payment: PaymentInterface = this.props.payment;

    return (
			<div 
				style={{
					height: "38px",
					display: "inline-flex", 
					flexDirection: "column", 
					justifyContent: payment.getPayerDisplayName() && payment.description ? "space-between" : payment.getPayerDisplayName() ? "flex-start" : "flex-end"
				}}
			>
				{
					payment.getPayerDisplayName() && (
						<div>
							{payment.getPayerDisplayName()}
						</div>
					)
				}
				{
					payment.description && (
						<div style={{fontSize: "12px", color: "gray"}}>{`${payment.description && typeof payment.description === "string" ? payment.description : "" }`}</div>
					)
				}
			</div>
    );
  }
}
